var map = {
	"./en.json": 400,
	"./zh-hk.json": 905
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 904;


//////////////////
// WEBPACK FOOTER
// ./src/resource/intl ^\.\/.*\.json$
// module id = 904
// module chunks = 0